const temporaryKeys = new WeakMap<object, string>();
let nextTemporaryKey = 0;

/** Persisted identity first; transient facets keep their identity across renders and reordering. */
export function planObjectKey(object: { readonly id: string; readonly owner?: { readonly id: string } }): string {
  const id = object.owner?.id || object.id;
  if (id) return `id:${id}`;
  const identity = object.owner ?? object;
  let key = temporaryKeys.get(identity);
  if (!key) {
    key = `temporary:${++nextTemporaryKey}`;
    temporaryKeys.set(identity, key);
  }
  return key;
}
